import { DetailedHTMLProps, PropsWithChildren } from 'react';
import cn from 'classnames';
import styles from './input-field.module.scss';

type InputFieldProps = PropsWithChildren<
  DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>
> & {
  label: string;
  invalid: boolean;
  name: string;
  helperText?: string;
  ref?: React.ForwardedRef<HTMLInputElement>;
  className?: string;
};

export const InputField = ({
  label,
  invalid,
  className,
  children,
  name,
  helperText,
  ref,
  ...props
}: InputFieldProps) => {
  const id = `field-${name}`;
  const helperId = helperText ? `${id}-helper` : undefined;

  return (
    <div className={styles.field}>
      <label htmlFor={id} className={styles.label}>
        {label}
      </label>
      <div className={styles.wrapper}>
        <input
          id={id}
          ref={ref}
          name={name}
          className={cn(styles.input, className)}
          aria-invalid={invalid}
          aria-describedby={helperId}
          {...props}
        />
        {helperText && (
          <small id={helperId} className={styles.helperText}>
            {helperText}
          </small>
        )}
        {children}
      </div>
    </div>
  );
};
